import {createSessionDto} from "../create-service-service";
import {CreateSessionFormValues} from "../reducers/create-session/types";
import {useCreateSession, Session} from "../../../../features/sessions";
import {useCreateSessionContext} from "../context/create-session";

interface HookResult {
  createSession(values: CreateSessionFormValues): void;
  wasSessionCreated: boolean;
  isCreatingSession: boolean;
  responseData?: Session;
}

export function useCreateService(): HookResult {
  const {dispatch} = useCreateSessionContext();
  const createSessionMutation = useCreateSession();

  const createSession = (values: CreateSessionFormValues) => {
    createSessionMutation.mutate(createSessionDto(values), {
      onSuccess(session) {
        dispatch({
          type: "go-to-cover-images-upload-form-step",
          payload: {session, formData: values},
        });
      },
    });
  };

  return {
    createSession,
    wasSessionCreated: createSessionMutation.isSuccess,
    isCreatingSession: createSessionMutation.isPending,
    responseData: createSessionMutation.isSuccess
      ? createSessionMutation.data
      : undefined,
  };
}
